"use client"

import { useEffect, useState, useRef } from "react"
import styles from "./styles.module.css"
import toast from "react-hot-toast"

// COMPONENTS
import Button from "../modules/Button/Button"
import Modal from "../modules/Modal/Moadal"
import Tabs from "../modules/Tabs/Tabs"
import OrderBulk from "./bulk"

// API
import { createTenoviBulkOrder } from "../../../services/inventory/detail"

const Order = ({ isOpen, setIsOpen }) => {
  const [addType, setAddType] = useState(2) // Start with bulk order tab (2) instead of individual (1)
  const [isPlacingOrder, setIsPlacingOrder] = useState(false)

  const orderBulkRef = useRef()
  const emailPreviewRef = useRef()


  const placeOrderHandler = async () => {
    try {
      setIsPlacingOrder(true)

      // Get devices from OrderBulk component
      const devices = orderBulkRef.current?.getDevices?.() || []
      if (!devices || devices.length === 0) {
        toast.error("Please add at least one device to the order")
        return
      }

      // Get email data from EmailPreview component
      const emailData = emailPreviewRef.current?.getEmailData?.() || {}
      if (!emailData.to || !emailData.subject || !emailData.body) {
        toast.error("Please complete all email fields")
        return
      }

      // Construct API payload
      const payload = {
        to_email: emailData.to,
        subject: emailData.subject,
        body: emailData.body,
        items: devices.map((device) => ({
          device_type: device.id, // This should be device type ID from API
          quantity: Number.parseInt(device.quantity),
        })),
      }

      // Send bulk order request
      const result = await createTenoviBulkOrder(payload)

      if (result.success) {
        toast.success("Tenovi bulk order created successfully")
        // Reset form and close modal
        orderBulkRef.current?.resetForm?.()
        setIsOpen(false)
        setAddType(2) // Reset to bulk order tab
      } else {
        toast.error(result.message || "Failed to create bulk order")
      }
    } catch (error) {
      console.error("Error placing bulk order:", error)
      toast.error("Failed to create bulk order")
    } finally {
      setIsPlacingOrder(false)
    }
  }

  useEffect(() => {
    console.log("addType", addType)
  }, [addType])

  return (
    <Modal
      title="Order Devices"
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      width="60%"
      footer={
        <>
          {addType === 3 ? (
            <Button variant="secondary" size="small" onClick={() => setAddType(2)}>
              Previous
            </Button>
          ) : (
            <Button variant="secondary"  size="small" onClick={() => setIsOpen(false)}>
              Cancel
            </Button>
          )}

          {addType === 2 ? (
            <Button  size="small" onClick={() => setAddType(3)}>Next</Button>
          ) : (
            <Button size="small" onClick={placeOrderHandler} disabled={isPlacingOrder}>
              {isPlacingOrder ? "Placing Order..." : "Place Order"}
            </Button>
          )}
        </>
      }
    >
  
      {/* {addType === 1 ? (
        <OrderIndividual />
      ) : ( */}
      <OrderBulk ref={orderBulkRef} emailPreviewRef={emailPreviewRef} addType={addType} setAddType={setAddType} />
      {/* )} */}
    </Modal>
  )
}

export default Order
